export enum TradeStatus {
	Pending = 'pending',
	Win = 'win',
	Lose = 'lose',
}
